

function FooterCopyright() {
  return (
    <p>{ `© ${ (new Date()).getFullYear() } Wily Global Inc.` }</p>
  )
}

export default FooterCopyright